module.exports = __webpack_public_path__ + "static/about-us-pic-395a197701b655ff3ac59503d442d6aa.jpg";